import { useQuery } from "../../Utils/utils"

export const useRequestsPageQuery = (search) => {
  const query = useQuery(search)
  return {
    folder: query.get("folder"),
    // `receipts` tab uses `?status=` (per Receipt Admin plan §3.3). Other tabs — `?folder=`.
    status: query.get("status"),
    addCommentRequestID: query.get("add_comment")
  }
}
